// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../projects/assets/AssetPreview.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerRequirementsQueryVariables = Types.Exact<{
  tradePartnerId: Types.Scalars['ID']['input'];
}>;


export type TradePartnerRequirementsQuery = { __typename?: 'Query', tradePartner: { __typename?: 'TradePartner', id: string, requirements: Array<{ __typename?: 'TradePartnerRequirement', id: string, licenseNumber?: string | null | undefined, expirationDate?: Types.Scalars['Date']['input'] | null | undefined, signedDate?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, type: { __typename?: 'TradePartnerRequirementTypeDetail', code: Types.TradePartnerRequirementType, name: string, isTsa: boolean }, tradePartner: { __typename?: 'TradePartner', id: string }, status: { __typename?: 'TradePartnerRequirementStatusDetail', code: Types.TradePartnerRequirementStatus, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> }> }, tradePartnerRequirementTypes: Array<{ __typename?: 'TradePartnerRequirementTypeDetail', code: Types.TradePartnerRequirementType, name: string, isTsa: boolean }>, tradePartnerRequirementStatuses: Array<{ __typename?: 'TradePartnerRequirementStatusDetail', code: Types.TradePartnerRequirementStatus, name: string }> };

export type SaveTradePartnerRequirementMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerRequirementInput;
}>;


export type SaveTradePartnerRequirementMutation = { __typename?: 'Mutation', saveTradePartnerRequirement: { __typename?: 'SaveTradePartnerRequirementResult', tradePartnerRequirement: { __typename?: 'TradePartnerRequirement', id: string, licenseNumber?: string | null | undefined, expirationDate?: Types.Scalars['Date']['input'] | null | undefined, signedDate?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, type: { __typename?: 'TradePartnerRequirementTypeDetail', code: Types.TradePartnerRequirementType, name: string, isTsa: boolean }, tradePartner: { __typename?: 'TradePartner', id: string }, status: { __typename?: 'TradePartnerRequirementStatusDetail', code: Types.TradePartnerRequirementStatus, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> } } };

export type RequirementsTabTradePartnerRequirementFragment = { __typename?: 'TradePartnerRequirement', id: string, licenseNumber?: string | null | undefined, expirationDate?: Types.Scalars['Date']['input'] | null | undefined, signedDate?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, type: { __typename?: 'TradePartnerRequirementTypeDetail', code: Types.TradePartnerRequirementType, name: string, isTsa: boolean }, tradePartner: { __typename?: 'TradePartner', id: string }, status: { __typename?: 'TradePartnerRequirementStatusDetail', code: Types.TradePartnerRequirementStatus, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export type TradePartnerRequirementTypeDataFragment = { __typename?: 'TradePartnerRequirementTypeDetail', code: Types.TradePartnerRequirementType, name: string, isTsa: boolean };

export type TradePartnerRequirementStatusDataFragment = { __typename?: 'TradePartnerRequirementStatusDetail', code: Types.TradePartnerRequirementStatus, name: string };

export const RequirementsTabTradePartnerRequirementFragmentDoc = gql`
    fragment RequirementsTabTradePartnerRequirement on TradePartnerRequirement {
  id
  type {
    code
    name
    isTsa
  }
  licenseNumber
  expirationDate
  signedDate
  internalNote
  tradePartner {
    id
  }
  status {
    code
    name
  }
  attachments {
    id
    asset {
      ...AssetInfo
    }
  }
}
    ${AssetInfoFragmentDoc}`;
export const TradePartnerRequirementTypeDataFragmentDoc = gql`
    fragment TradePartnerRequirementTypeData on TradePartnerRequirementTypeDetail {
  code
  name
  isTsa
}
    `;
export const TradePartnerRequirementStatusDataFragmentDoc = gql`
    fragment TradePartnerRequirementStatusData on TradePartnerRequirementStatusDetail {
  code
  name
}
    `;
export const TradePartnerRequirementsDocument = gql`
    query TradePartnerRequirements($tradePartnerId: ID!) {
  tradePartner(id: $tradePartnerId) {
    id
    requirements {
      ...RequirementsTabTradePartnerRequirement
    }
  }
  tradePartnerRequirementTypes {
    ...TradePartnerRequirementTypeData
  }
  tradePartnerRequirementStatuses {
    ...TradePartnerRequirementStatusData
  }
}
    ${RequirementsTabTradePartnerRequirementFragmentDoc}
${TradePartnerRequirementTypeDataFragmentDoc}
${TradePartnerRequirementStatusDataFragmentDoc}`;

/**
 * __useTradePartnerRequirementsQuery__
 *
 * To run a query within a React component, call `useTradePartnerRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerRequirementsQuery({
 *   variables: {
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useTradePartnerRequirementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables> & ({ variables: TradePartnerRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>(TradePartnerRequirementsDocument, options);
      }
export function useTradePartnerRequirementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>(TradePartnerRequirementsDocument, options);
        }
// @ts-ignore
export function useTradePartnerRequirementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>;
export function useTradePartnerRequirementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerRequirementsQuery | undefined, TradePartnerRequirementsQueryVariables>;
export function useTradePartnerRequirementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>(TradePartnerRequirementsDocument, options);
        }
export type TradePartnerRequirementsQueryHookResult = ReturnType<typeof useTradePartnerRequirementsQuery>;
export type TradePartnerRequirementsLazyQueryHookResult = ReturnType<typeof useTradePartnerRequirementsLazyQuery>;
export type TradePartnerRequirementsSuspenseQueryHookResult = ReturnType<typeof useTradePartnerRequirementsSuspenseQuery>;
export type TradePartnerRequirementsQueryResult = Apollo.QueryResult<TradePartnerRequirementsQuery, TradePartnerRequirementsQueryVariables>;
export const SaveTradePartnerRequirementDocument = gql`
    mutation SaveTradePartnerRequirement($input: SaveTradePartnerRequirementInput!) {
  saveTradePartnerRequirement(input: $input) {
    tradePartnerRequirement {
      ...RequirementsTabTradePartnerRequirement
    }
  }
}
    ${RequirementsTabTradePartnerRequirementFragmentDoc}`;
export type SaveTradePartnerRequirementMutationFn = Apollo.MutationFunction<SaveTradePartnerRequirementMutation, SaveTradePartnerRequirementMutationVariables>;

/**
 * __useSaveTradePartnerRequirementMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerRequirementMutation, { data, loading, error }] = useSaveTradePartnerRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerRequirementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerRequirementMutation, SaveTradePartnerRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerRequirementMutation, SaveTradePartnerRequirementMutationVariables>(SaveTradePartnerRequirementDocument, options);
      }
export type SaveTradePartnerRequirementMutationHookResult = ReturnType<typeof useSaveTradePartnerRequirementMutation>;
export type SaveTradePartnerRequirementMutationResult = Apollo.MutationResult<SaveTradePartnerRequirementMutation>;
export type SaveTradePartnerRequirementMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerRequirementMutation, SaveTradePartnerRequirementMutationVariables>;